import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=6456a444&"
import script from "./Address.vue?vue&type=script&lang=js&"
export * from "./Address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6456a444')) {
      api.createRecord('6456a444', component.options)
    } else {
      api.reload('6456a444', component.options)
    }
    module.hot.accept("./Address.vue?vue&type=template&id=6456a444&", function () {
      api.rerender('6456a444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/transactions/forms/Address.vue"
export default component.exports